import React from 'react';
import CheckboxTree from 'react-checkbox-tree';

const CommonTree = ({
    nodes,
    checked,
    setChecked,
    expanded,
    setExpanded,
}) => {

  const handleCheck = (checked) => {
    setChecked(checked);
  };

  const handleExpand = (expanded) => {
    setExpanded(expanded);
  };

  return (
      <CheckboxTree
        nodes={nodes}
        checked={checked}
        expanded={expanded}
        onCheck={handleCheck}
        onExpand={handleExpand}
      />
  );
};

export default CommonTree;
